<app-navbar-public />
<app-scroll-to-top />
<router-outlet />

@switch (footerType()) {
  @case ("contact") {
    <app-footer [flush]="true" style="--footer-bg: #F2F2F2"/>
  }
  @default {
    <app-footer-public />
  }
}